import PropTypes from 'prop-types'

import Loader from '../../../Loader/Loader'

const EventLoader = ({ isLoading }) => {
  if (!isLoading) {
    return null
  }

  return (
    <div className="event-form-loader-container">
      <Loader />
    </div>
  )
}

EventLoader.propTypes = {
  isLoading: PropTypes.bool,
}

export default EventLoader
